<template>
    <div class="admin__advertiser__context">
        <advertiser-pop-up v-if="popup" @closePopup="hidePopup" :advertiser="activeAdvertiser"></advertiser-pop-up>

        <div class="content" v-if="!popup">
            <h1>Advertisers</h1>
            <div class="table__content">
                <div class="search__content">
                  <label>Show rows
                      <select class="input-filed perpage__value__section" ref="selectFilter" name="perpage__field" v-model="perPage"  @change="changePerpage($event)">
                            <option value="10">10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </label>
                    <input type="text" @keyup.enter="search" class="search__value__section" placeholder="Search" v-model="searchParameter" :onchange="checkInput()" style="background: #FFFFFF; border: 2px solid #2EA3FF; box-sizing: border-box; border-radius: 5px; margin-right: 15px; height: 34px; width: 200px; padding-left: 15px; color: #9F9F9F; font-weight: 600; font-size: 14px;">
                    <button @click="search" class="btn__search">Search</button>
                </div>
                <div class="table__container">
                    <table style="width: 100%">
                        <tr>
                            <th>
                                <span>
                                    {{this.isMobile() ? 'ID': ' ADVERTISER ID' }}
                                    <div @click="sort(0)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th>
                                <span>
                                   {{this.isMobile() ? 'NAME': ' ADVERTISER NAME' }}

                                    <div @click="sort(1)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th>
                                <span>
                                    # OF CAMPAIGNS
                                    <div @click="sort(3)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th>
                                <span>
                                    BUDGET
                                    <div @click="sort(2)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                        </tr>
                        <tr v-for="advertiser in paginationAdvertiser" v-bind:key="advertiser.id" class="table__data" @click="showPopup(advertiser)">
                            <td>{{advertiser.id}}</td>
                            <td>{{advertiser.name}}</td>
                            <td>{{advertiser.campaigns}}</td>
                            <td>{{advertiser.budget}}</td>
                        </tr>
                    </table>
                    <paginate
                        v-if="advertisers.length > 0"
                        v-model="advertiserNumber"
                        :page-count="advertiserTotal"
                        :container-class="'paginationContainer'"
                        :active-class="'paginationActive'"
                        :click-handler="advertiserPaggination">
                    </paginate>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import toast from '@utils/toast.js'
import AdvertiserPopUp from './AdminAdvertiserPopUp.vue'
import Search from '@utils/Search.js'
import { paginateList, paginationTotal } from '@utils/pagination.js'
export default {
    name: 'AdminAdvertisers',
    data: function () {
        return {
            advertisers: [],
            popup: false,
            advertisersSearch: [],
            searchParameter: '',
            startParameter: false,
            sorts: [false, false, false, false],
            activeAdvertiser: {},
            advertiserNumber: 1,
            advertiserTotal: 1,
            perPage: 10
        }
    },
    components: {
        AdvertiserPopUp
    },
    methods: {
        getAdvertisers () {
            let data = {}
            this.request('/admin/list/advertisers', 'POST', data).then(response => {
                if (response.code === 0) {
                    toast.successMessage('Data is received')
                    this.advertisers = response.data
                    this.advertisersSearch = response.data

                    this.setTotalPagginationLength()
                } else {
                    toast.errorMessage(response.message)
                    if (response.code === 112) {
                        this.checkTokenConditions(this.getAdvertisers)
                    }
                }
            }).catch(error => {
                toast.errorMessage(error)
            })
        },
        showPopup (advertiser) {
            this.popup = true
            this.activeAdvertiser = advertiser
        },
        hidePopup (updatedUser) {
          this.popup = false
          if(Object.keys(updatedUser).length != 0){
              let oldAdvertiser=this.advertisers.find(el=>el.id == updatedUser.data.advertiser_id)
              oldAdvertiser.name =updatedUser.data.firstname+" "+updatedUser.data.surname;
              console.log("Updated user",updatedUser)
          }

        },
        checkInput () {
            if ( this.searchParameter === '' && this.startParameter) {
                this.advertisers = this.advertisersSearch
                this.setTotalPagginationLength()
            } else {
                if (this.searchParameter.length > 0) {
                    this.startParameter = true
                }
            }
        },
        search () {
            if (this.searchParameter !== '') {
                var inputFileds = null
                var string = false
                var extra = null

                if (isNaN(this.searchParameter)) {
                    inputFileds = [1]
                    string = true
                    extra = [2]
                } else {
                    inputFileds = [0, 3]
                    this.searchParameter = parseInt(this.searchParameter)
                    extra = [2]
                }

                var searchObject = new Search(inputFileds, this.advertisersSearch, this.searchParameter, Object.keys(this.advertisersSearch[0]), string, extra)
                searchObject.search().then((value) => {
                    if (value.length === 0) {
                        toast.simpleMessage('No result found from the search')
                    } else {
                        toast.successMessage('Search result received')
                    }
                    this.advertisers = value
                    this.setTotalPagginationLength()
                })
            }
        },
        sort (value) {
            this.sorts[value] = !this.sorts[value]
            if (this.sorts[value]) {
                toast.simpleMessage('Sort type: Ascending')
            } else {
                toast.simpleMessage('Sort type: Descending')
            }
            this.advertisers.sort((a, b) => {
                return b[Object.keys(b)[value]] < a[Object.keys(a)[value]] ? !this.sorts[value] ? -1 : 1
                : b[Object.keys(b)[value]] > a[Object.keys(a)[value]] ? this.sorts[value] ? -1 : 1
                : 0
            })
        },
        advertiserPaggination (number) {
            this.advertiserNumber = number
        },
        changePerpage(event){
          if(event.target.value == this.advertisers.length){
              this.perPage = this.advertisers.length
          }else{
            this.perPage = event.target.value
          }

          this.setTotalPagginationLength()
      },
        setTotalPagginationLength () {
            this.advertiserTotal = paginationTotal(this.advertisers.length,this.perPage)
        },
        checkTokenConditions (callback) {
            try{
                var expiresDate = new Date(this.token.expires)
            } catch (err) {
                this.$router.push('/login')
            }
            var now = new Date()
            if (expiresDate <= now) {
                this.store.commit('setToken', {})
                this.$router.push('/login')
            } else {
                var body = {
                code: '',
                refresh_token: this.token.refresh_token
                }
                this.request('/refresh/token', 'POST', body).then((response) => {
                if (response.code === 0 ) {
                    store.commit('setToken', response.data[0])
                    store.commit('setDriver', response.data[0].driver)
                    callback()
                } else if (response.code === 112) {
                    this.store.commit('setToken', {})
                    this.$router.push('/login')
                }
                }).catch((error) => {
                })
            }
            var token = this.token
            token.redirect = false
            this.store.commit('setToken', token)
        }
    },
    created: function () {
        this.getAdvertisers()
    },
    computed: {
      paginationAdvertiser: function () {
        return paginateList(this.advertisers, this.advertiserNumber, this.perPage)
        }
    },
    watch:{
     perPage:function(){
          if(this.perPage == this.advertisers.length){
            this.advertiserNumber =1;
          }
      }
    }

}
</script>

<style scoped>

.admin__advertiser__context{
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: hidden;
    text-align: left;
    box-sizing: border-box;
    position: relative;
}

th {
    width: 16%;
    border-collapse: collapse;
}

th span {
    display: flex;
    white-space: nowrap;
}

th div {
    display: inline-block;
    margin-left: 5px;
    position: relative;
}

.table__data {
    height: 50px;
}

table{
    border-collapse: separate;
    border-spacing: 0 8px;
    border-style: hidden;
}

td{
    cursor: pointer;
}

table {
    border-collapse: separate !important;
}

td {
    border: solid 1px transparent;
    background: rgba(235, 234, 244, 0.25);
}

table tr td:first-child {
    border-top-left-radius: 15px;
    border-left-width:15px;
    border-bottom-left-radius: 15px;
}

table tr td:last-child {
    border-top-right-radius: 15px;
    border-right-width:15px;
    border-bottom-right-radius: 15px;
}

.content {
    text-align: left;
    padding: 20px;
}

.content h1 {
    margin-top: 59px;
}

.table__content {
    margin-top: 58px;
}

.header__section{
    display: block;
    margin-right: 45px;
}

.sort__up {
    position: absolute;
}

.header__name{
    display: inline-block;
}

.header__style{
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;

    /* identical to box height */

    color: #1F1F1F;
}

.header__sort{
    display: inline-block;
    position: relative;
    margin-left: 10px;
    top: 2px;
}

.advertiser__list{
    max-height: 49vh;
    overflow: auto;
}

.table__element{
    display: flex;
    padding: 0px 0px 5px 15px;
    background: rgb(235, 234, 244) none repeat scroll 0% 0%;
    opacity: 0.48;
    border-radius: 0.5em;
}

.search__content{
    text-align: right;
    margin-bottom: 25px;
}

.search__value__section, .perpage__value__section  {
    background: #FFFFFF;
    border: 2px solid #2EA3FF;
    box-sizing: border-box;
    border-radius: 5px;
    margin-right: 15px;
    height: 34px;
    width: 200px;
    padding-left: 15px;
    color: #9F9F9F;
    font-weight: 600;
    font-size: 14px;
}

.btn__search {
    background: #2EA3FF;
    border: 2px solid #2EA3FF;
    border-radius: 5px;
    color: #fff;
    height: 34px;
    width: 86px;
    font-weight: 600;
    font-size: 13px;
}

.sort__image{
    widows: 17px;
    height: 7px;
    margin: 0 5px;
    cursor: pointer;
}
.search__content label{
    float:left;
}

@media only screen and (max-width: 1200px){
  .content h1 {
    margin-top: 20px;
     margin-bottom: 20px;
    }
    .search__content label{
        margin: 15px 0;
    }
}

@media only screen and (max-width: 750px) {
    .search__content {
        text-align: left;
    }

    .paginationContainer {
        float: left;
        padding-left: 0px;
    }

    .sort__image {
        height: 6px;
        top: 1px;
    }

    th {
        font-size: 15px;
        padding-right: 5px;
    }
}

@media only screen and (max-width: 640px) {
    td {
        font-size: 14px;
    }

    .sort__image {
        height: 5px;
        top: 3px;
    }
}
@media only screen and (min-width: 600px) and (max-width: 1024px) {

     .search__content label{
         margin:0 !important;
     }
     .btn__search{
        margin-right: 15px;
        margin-top: 10px;
     }
}

</style>
